import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { PlayVideo } from '../components/blocks/PlayVideo';

export const isPlayVideo = isElementType(PlayVideo);
